import { styled } from "styled-components";

export const DropBoxWrapper = styled.div<{ isBig?: boolean; width?: string }>`
  height: ${(p) => (p.isBig ? "50px" : "40px")};
  padding: ${(p) => (p.isBig ? "0 22px" : " 0 10px")};
  border-radius: 15px;
  gap: ${(p) => (p.isBig ? "10px" : " 5px")};
  border: 1px solid #b7b7b7;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Pretendard;
  font-size: ${(p) => (p.isBig ? "20px" : "12px")};
  font-weight: ${(p) => (p.isBig ? "600" : "500")};
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  width: auto;

  > .name {
    width: ${(p) => (p.width ? p.width : "auto")};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
  }

  > img {
    width: ${(p) => (p.isBig ? "10px" : "8px")};
    height: auto;
  }
`;

export const DropBoxItemWrapper = styled.div<{ isBig?: boolean }>`
  position: absolute;
  border-radius: 8px;
  gap: 4px;
  padding: ${(p) => (p.isBig ? "15px" : " 12px")};
  box-shadow: 0px 0px 8px 0px #0000001f;
  top: 50px;
  right: 0;
  z-index: 1000;
  background: #fff;
  display: flex;
  flex-direction: column;
  width: auto;
  max-height: 550px;
  overflow: auto;
  scrollbar-width: none;
  min-width: calc(100% - 24px);
`;

export const DropBoxItem = styled.div<{ selected: boolean; isBig?: boolean }>`
  white-space: nowrap;
  width: auto;
  height: ${(p) => (p.isBig ? "40px" : "30px")};
  border-radius: ${(p) => (p.isBig ? "20px" : "15px")};
  padding: ${(p) => (p.isBig ? "0 24px" : "0 12px")};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border: 1px solid var(--Black-100, #f0f0f0);
  gap: 8px;
  flex-shrink: 0;
  font-size: ${(p) => (p.isBig ? "17px" : "12px")};
  font-weight: ${(p) => (p.isBig ? "500" : "500")};

  ${(p) =>
    p.selected
      ? `
    background: var(--Purple-300, #6436e7);
    color: #fff;
  `
      : ""}
`;
